<template>
	<!-- :default-actions="!!devices.length" -->
	<tile-card
		:action-title="actionTitle"
		:aspect-ratio="3 / 2"
		:to="{ name: 'Live Devices' }"
		:disabled="unavailable"
	>
		<div v-if="!loading && devices.length === 0" class="body flex-column text-center">
			<v-icon class="flex-grow-1" color="grey lighten-2">fa-plug</v-icon>
			<span class="font-italic">{{ emptyText }}</span>
		</div>
		<v-card-text v-else class="grid-container">
			<template v-if="loading">
				<div v-for="i in 6" :key="i">
					<v-responsive aspect-ratio="1">
						<v-skeleton-loader
							type="image"
							:boilerplate="!loading"
							height="100%"
						/>
					</v-responsive>
				</div>
			</template>
			<div v-for="(widget, i) in devices" v-else :key="i">
				<component :is="widgetTypes[widget.type]" :node="widget.node" />
			</div>
		</v-card-text>
	</tile-card>
</template>

<style lang="scss" scoped>
.grid-container {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	grid-template-rows: 1fr 1fr;
	gap: 9px;

	::v-deep .v-skeleton-loader__image.v-skeleton-loader__bone {
		height: 100%;
	}

	@media #{map-get($display-breakpoints, 'sm-and-up')} {
		gap: 12px;
	}
}
</style>

<script>
import _ from "lodash";

import { CLS_SENSOR } from "@/utils/k4util";

import TileCard from "../../shared/TileCard";

import LightWidget from "./widget/Light";
import MotionWidget from "./widget/Motion";
import ThermoWidget from "./widget/Thermostat";

export default {
	components: {
		TileCard,

		LightWidget,
		MotionWidget,
		ThermoWidget,
	},

	data: () => ({
		validGroups: ["lights", "thermostats"],

		widgetTypes: {
			lights: LightWidget,
			thermostats: ThermoWidget,
			motion: MotionWidget,
		},
	}),

	computed: {
		loading() {
			return this.$store.getters["controller/connecting"];
		},

		unavailable() {
			return this.$store.getters["controller/state"] < 1;
		},

		nodes() {
			return _.get(this.$store.state.controller.nodes, "nodes", []);
		},

		devices() {
			let devices = _.chain(this.nodes)
				.reduce((accum, node) => {
					const group = node.meta.group;
					const extendz = node.meta.extends;
					if (_.includes(extendz, CLS_SENSOR))
						accum.push({ type: "motion", node });
					else if (this.validGroups.includes(group))
						accum.push({ type: group, node });
					return accum;
				}, [])
				.filter((node) => node.node.configured)
				.value();

			devices = devices.slice(0, 6);
			return devices;
		},

		actionTitle() {
			if (this.loading) return "Devices";
			if (this.unavailable) return false;

			// Total # of devices vs devices we're creating widgets for
			const rooms = this.$store.getters["controller/nodes/rooms"];
			const totalDevices = _.sum(
				_.map(rooms, (room) => (room.children || []).length)
			);
			return `${totalDevices} Devices`;
		},

		emptyText() {
			return this.unavailable
				? "Cannot load devices. Controller is unavailable."
				: "Have you added any devices yet?";
		},
	},
};
</script>
